import React, { useState } from "react";
import casestudy from "../../assets/FlipImages/1.png";
import it from "../../assets/FlipImages/1.png";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import bgblog2 from "../../assets/images/blogs/bf-blog-2.png";
import bgblog4 from "../../assets/images/blogs/bf-blog-4.png";
import latestblog from "../../assets/images/blogs/latestblogimg1.jpeg";
import fbar from "../../assets/images/blogs/FBAR1.png";
import fbar1 from "../../assets/images/blogs/FBAR2.png";
import fbar3 from "../../assets/images/blogs/FBAR4.png";
import rule2025 from "../../assets/images/blogs/rule-2025.png";
import rule12025 from "../../assets/images/blogs/rule1-2025.png";
import financeplan2025 from "../../assets/images/blogs/financeplan-2025.png";

const BeyondBookKeeping = () => {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [comments, setComments] = useState([]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWebsiteChange = (event) => {
    setWebsite(event.target.value);
  };

  const handleSaveInfoChange = (event) => {
    setSaveInfo(event.target.checked);
  };

  const handleCommentSubmit = () => {
    if (comment.trim() && name.trim() && email.trim()) {
      setComments([...comments, { comment, name, email, website }]);
      setComment("");
      setName("");
      setEmail("");
      setWebsite("");
      setSaveInfo(false);
    }
  };

  return (
    <>
      <style jsx>{`
        h4 {
          font-size: 18px;
        }
        h3 {
          font-size: 28px;
        }
        span {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
        li {
          font-size: 16px;
          font-weight: 500;
        }
        .mainCard {
          height: 20rem;
        }
        .circle {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          overflow: hidden;
        }
        i {
          color: #072f5f;
        }
        ul {
          padding-left: 17px;
        }
        @media (max-width: 574px) {
          .mTop {
            margin-top: 30px;
          }
          p {
            font-size: 18px;
          }
          .img-fluid {
            min-height: 100px;
          }
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (min-width: 992px) {
          /* for banner image */
          .bmTop {
            margin-top: 130px;
          }
        }
        @media (max-width: 574px) {
          .banner-image {
            margin-top: 70px; /* Adjust this value for mobile view */
          }
        }
      `}</style>

      <section className="">
        <div
          className="d-flex justify-content-center align-items-center banner-image"
          style={{
            background: `url(${casestudy}) no-repeat center`,
            backgroundSize: "cover",
            height: "200px",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3
              className="text-white text-uppercase text-center"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Beyond Bookkeeping
            </h3>
          </div>
        </div>
        <div className="container-fluid">
          <div
            className="d-flex row justify-content-center align-items-start"
            style={{ gap: "2rem" }}
          >
            <div
              className="col-lg-8 mt-50 mb-50 border shadow"
              style={{ padding: "2rem" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                  <div
                    style={{
                      background: "#072f5f",
                      display: "inline",
                      width: "fit-content",
                      padding: "0.2rem 1rem 0.2rem 1rem",
                    }}
                  >
                    <small
                      className="text-uppercase text-white"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Introduction
                    </small>
                  </div>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      ></span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      In today’s fast-paced business world, the role of finance
                      is evolving rapidly. At Boston Financial Advisory Group,
                      we recognize that the days of merely keeping the books are
                      behind us. As international businesses face increasingly
                      complex challenges, the demand for strategic financial
                      guidance is growing. It’s no longer just about
                      numbers—it’s about using financial expertise to drive
                      growth and innovation.
                    </p>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Seeing the Shift
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Bookkeeping was traditionally about maintaining accounting
                      records and producing accurate financial statements. But
                      as companies expand globally, they must contend with
                      intricate issues like regulatory compliance, foreign
                      exchange fluctuations, and market volatility. This shift
                      calls for a strategic financial approach—far beyond basic
                      record-keeping.
                    </p>

                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        The Role of Strategic Financial Advisory
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      At Boston Financial Advisory Group, strategic financial
                      consulting encompasses a range of services designed to
                      help businesses navigate financial complexities. Our
                      experienced consultants provide insights that support
                      decision-making, enhance financial performance, and
                      strengthen overall business strategy.
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Below are a few critical ways our strategic financial
                      consulting can benefit your organization:{" "}
                    </p>
                  </div>

                  <div className="mt-15">
                    <span
                      className="text-capitalize"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#002249",
                      }}
                    >
                      1. Financial Planning and Analysis (FP&A)
                    </span>
                  </div>
                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>
                      FP&A is essential for forecasting future performance and
                      enabling data-driven decisions. We work closely with
                      clients to build robust financial models, identify key
                      data trends, and uncover actionable insights. This
                      forward-looking approach allows firms to anticipate risks
                      and seize opportunities proactively.
                    </li>
                  </ul>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        2. Risk Management
                      </span>
                    </div>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        In the global marketplace, risks stem from a variety of
                        sources—economic shifts, geopolitical tensions, and
                        evolving regulations. Our financial experts analyze
                        these risks and develop customized mitigation
                        strategies. By anticipating potential challenges, we
                        help businesses safeguard their assets and maintain
                        long-term stability.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        3. Mergers and Acquisitions (M&A)
                      </span>
                    </div>
                  </div>
                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>
                      For companies looking to grow through mergers and
                      acquisitions, our advisory services are invaluable. We
                      conduct comprehensive due diligence, evaluate financial
                      health, and provide expert valuation guidance. Our
                      consultants help ensure informed decision-making
                      throughout the M&A process—leading to more successful
                      outcomes.
                    </li>
                  </ul>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                          textAlign: "justify",
                        }}
                      >
                        4. Performance Improvement
                      </span>
                    </div>
                  </div>
                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>
                      Our team evaluates current financial processes to identify
                      inefficiencies and areas for optimization. By eliminating
                      redundant steps and streamlining workflows, we help
                      businesses reduce costs and improve profitability.
                      Performance improvement is key to staying competitive in a
                      global market.
                    </li>
                  </ul>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                          textAlign: "justify",
                        }}
                      >
                        The Benefits of Strategic Financial Advisory
                      </span>
                    </div>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <p
                        className="text-dark servicep"
                        style={{ textAlign: "justify" }}
                      >
                        Partnering with Boston Financial Advisory Group for
                        strategic financial consulting delivers tangible
                        benefits:{" "}
                      </p>
                      <li>
                        Informed Decision-Making: Access to expert insights
                        empowers leaders to make strategic, data-backed choices.
                      </li>
                      <li>
                        Greater Agility: A clear understanding of financial
                        risks and opportunities allows organizations to adapt
                        quickly to market changes.{" "}
                      </li>
                      <li>
                        Sustainable Growth: Optimized financial performance and
                        long-term strategies position businesses for enduring
                        success.{" "}
                      </li>
                    </ul>
                  </div>

                  <img
                    src={bgblog4}
                    style={{
                      display: "block",
                      margin: "1rem auto",
                      width: "350px",
                      height: "270px",
                    }}
                  />
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Key Takeaway
                      </span>
                    </div>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        As the global business environment continues to evolve,
                        the importance of strategic financial consulting cannot
                        be overstated. Companies that embrace this
                        transformation won’t just manage their finances more
                        effectively—they’ll unlock new avenues for innovation
                        and growth.
                      </li>
                      <li>
                        In conclusion, moving beyond traditional bookkeeping
                        toward strategic financial consulting is essential for
                        international businesses to thrive in today's complex
                        world. Boston Financial Advisory Group is committed to
                        delivering the insight and guidance businesses need to
                        overcome challenges and succeed in an ever-changing
                        landscape.
                      </li>
                    </ul>
                  </div>

                  <Box
                    mt="2rem"
                    p="2rem"
                    border="1px solid #ddd"
                    borderRadius="8px"
                  >
                    <Typography variant="h5" gutterBottom>
                      Leave a Comment
                    </Typography>
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={comment}
                      onChange={handleCommentChange}
                      margin="normal"
                    />
                    <Box display="flex" gap="1rem">
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={handleNameChange}
                        margin="normal"
                      />
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={handleEmailChange}
                        margin="normal"
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={saveInfo}
                          onChange={handleSaveInfoChange}
                        />
                      }
                      label="Save my name, email, and website in this browser for the next time I comment."
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCommentSubmit}
                      style={{ backgroundColor: "rgb(0, 34, 73)" }}
                    >
                      Send Comment
                    </Button>
                  </Box>
                  <Box mt="2rem">
                    {comments.map((cmt, index) => (
                      <Box
                        key={index}
                        mt="1rem"
                        p="1rem"
                        border="1px solid #ddd"
                        borderRadius="8px"
                      >
                        <Typography variant="body1">{cmt.comment}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cmt.name} - {cmt.email}
                          {cmt.website && ` - ${cmt.website}`}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BeyondBookKeeping;
